define("shared/utils/plans-data/feature-upgrade", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * Maps features to upgrade flows
   * @param intl
   * @returns Popular features per plan type
   */
  const featureUpgradeMap = intl => ({
    additionalAiCreditsOnStarter: {
      planName: 'starter',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterStarter: {
      planName: 'starter',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterGrowth: {
      planName: 'growth',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterAdvanced: {
      planName: 'advanced',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterStarterFromFree: {
      planName: 'starter',
      featureName: intl.t('plans.ai_caption_writer.caption_writer')
    },
    aiCaptionWriterGrowthFromFree: {
      planName: 'growth',
      featureName: intl.t('plans.ai_caption_writer.caption_writer')
    },
    aiCaptionWriterAdvancedFromFree: {
      planName: 'advanced',
      featureName: intl.t('plans.ai_caption_writer.caption_writer')
    },
    groups: {
      planName: 'growth',
      featureName: intl.t('plans.groups')
    },
    stories: {
      planName: 'starter',
      featureName: intl.t('shared_phrases.schedule_stories')
    },
    searchByHashtag: {
      planName: 'starter',
      featureName: intl.t('plans.search_repost')
    },
    searchByProfile: {
      planName: 'starter',
      featureName: intl.t('shared_phrases.search_profile')
    },
    textOnImages: {
      planName: 'starter',
      featureName: intl.t('plans.text_on_images')
    },
    import: {
      planName: 'starter',
      featureName: intl.t('plans.import_url')
    },
    linkinbioAppBlock: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.mailchimp_for')
    },
    linkinbioBannerless: {
      planName: 'growth',
      featureName: intl.t('plans.linkin_bio.bannerless')
    },
    linkinbioButtonBlock: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.button_block')
    },
    linkinbioButtonColors: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.button_colors')
    },
    linkinbioButtonBoxShadow: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.button_shadows')
    },
    linkinbioButtonGroups: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.button_groups')
    },
    linkinbioButtonOutline: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.button_styles')
    },
    linkinbioButtonShape: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.button_shapes')
    },
    linkinbioButtons: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioEmbeddedGallery: {
      planName: 'growth',
      featureName: intl.t('plans.linkin_bio.embedded_gallery')
    },
    linkinbioExtendedClickAnalytics: {
      planName: 'growth',
      featureName: intl.t('plans.linkin_bio.click_analytics')
    },
    linkinbioFeaturedBanner: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.featured_banner')
    },
    linkinbioFeaturedMediaCustomImage: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.featured_media_custom_image')
    },
    linkinbioFeaturedMediaYouTube: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.featured_media_youtube')
    },
    linkinbioGeneric: {
      planName: 'growth',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioHeader: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioMultiLink: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioMultipleFeeds: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioPaidPlan: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioPageBackground: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.page_background')
    },
    linkinbioPageBackgroundImage: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.page_background_image')
    },
    linkinbioPageBlock: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.page_block')
    },
    linkinbioPageFont: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.page_font')
    },
    linkinbioPageText: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.page_text')
    },
    linkinbioPremiumThemes: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.premium_themes')
    },
    linkinbioSocialLinkList: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioTheme: {
      planName: 'growth',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioTiktok: {
      planName: 'starter',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    campaignBoard: {
      planName: 'creator',
      featureName: intl.t('plans.campaign_board')
    },
    contributors: {
      planName: 'growth',
      featureName: intl.t('shared_words.contributors')
    },
    conversations: {
      planName: 'growth',
      featureName: intl.t('plans.conversations')
    },
    analyticsStandard: {
      planName: 'growth',
      featureName: intl.t('plans.analytics_standard')
    },
    mediaKit: {
      planName: 'creator',
      featureName: intl.t('plans.media_kit')
    },
    mentions: {
      planName: 'growth',
      featureName: intl.t('plans.mentions')
    },
    tagged: {
      planName: 'starter',
      featureName: intl.t('plans.tagged')
    },
    multiPhoto: {
      planName: 'starter',
      featureName: intl.t('shared_phrases.multi_photo'),
      upgradeButtonQaClassName: 'qa--carouselUpsell_getMultiPhotoScheduling_Btn'
    },
    videos: {
      planName: 'starter',
      featureName: intl.t('plans.videos')
    },
    unlimitedHashtagSuggestions: {
      planName: 'starter',
      featureName: intl.t('plans.unlimited_hashtags')
    },
    bttp: {
      planName: 'starter',
      featureName: intl.t('plans.bttp')
    },
    tiktokBttp: {
      planName: 'starter',
      featureName: intl.t('plans.tiktok_bttp')
    },
    addMoreMedia: {
      planName: 'starter',
      featureName: intl.t('plans.multi_photo_scheduling')
    },
    unlimitedCollectFromTags: {
      planName: 'growth',
      featureName: intl.t('plans.unlimited_collect_from_tags')
    },
    userTagging: {
      planName: 'starter',
      featureName: intl.t('plans.user_tag')
    },
    igProductTagging: {
      planName: 'growth',
      featureName: intl.t('plans.product_tag')
    },
    locationTagging: {
      planName: 'starter',
      featureName: intl.t('plans.location_tag')
    },
    firstComment: {
      planName: 'starter',
      featureName: intl.t('shared_phrases.first_comment')
    },
    addSocialSets: {
      planName: 'growth',
      featureName: intl.t('plans.extra_social_sets')
    },
    addUsers: {
      planName: 'growth',
      featureName: intl.t('plans.extra_users')
    },
    twitterClickTracking: {
      planName: 'growth',
      featureName: intl.t('plans.twitter_click_tracking')
    },
    twitterAnalytics: {
      planName: 'growth',
      featureName: intl.t('plans.twitter_analytics')
    },
    pinterestClickTracking: {
      planName: 'growth',
      featureName: intl.t('plans.pinterest_click_tracking')
    },
    pinterestAnalytics: {
      planName: 'growth',
      featureName: intl.t('plans.pinterest_analytics')
    },
    performanceReport: {
      planName: 'growth',
      featureName: intl.t('plans.performance_report')
    },
    previewGrid: {
      planName: 'starter',
      featureName: intl.t('plans.highlight_mappings.auto_publish_reels')
    },
    tiktokAnalytics: {
      planName: 'starter',
      featureName: intl.t('plans.tiktok_analytics')
    },
    facebookAnalytics: {
      planName: 'starter',
      featureName: intl.t('plans.facebook_analytics')
    },
    largerVideos: {
      planName: 'starter',
      featureName: intl.t('plans.upload_larger_videos')
    },
    videoCover: {
      planName: 'starter',
      featureName: intl.t('plans.select_video_cover')
    },
    autoPublishCarousel: {
      planName: 'starter',
      featureName: intl.t('plans.auto_publish_carousel_posts')
    },
    autoHashtags: {
      planName: 'growth',
      featureName: intl.t('shared_phrases.hashtag_suggestions_auto')
    },
    searchHashtags: {
      planName: 'starter',
      featureName: intl.t('shared_phrases.hashtag_suggestions')
    },
    scheduleReels: {
      planName: 'starter',
      featureName: intl.t('plans.highlight_mappings.auto_publish_reels')
    },
    shareCalendar: {
      planName: 'growth',
      featureName: intl.t('plans.share_calendar')
    },
    partnershipSearch: {
      planName: 'growth',
      featureName: intl.t('plans.brand_collabs')
    },
    // For all features below this line, there are no upgrade points implemented.
    calendarNotes: {
      planName: 'growth',
      featureName: intl.t('plans.calendar_notes')
    },
    hashtagTrends: {
      planName: 'growth',
      featureName: intl.t('plans.hashtag_trends')
    }
  });

  var _default = featureUpgradeMap;
  _exports.default = _default;
});